import { useWindowDimensionsContext } from './useWindowDimensionsContext';
import { useBreakpoint } from './useBreakpoint';
export const useDeviceSize = () => {
  const {
    deviceWidth
  } = useWindowDimensionsContext();
  return useBreakpoint(deviceWidth);
};